module.exports = __webpack_public_path__ + "static/media/ua.898a0af0.svg";